import { render } from "./CardInvoices.vue?vue&type=template&id=78795394&scoped=true"
import script from "./CardInvoices.vue?vue&type=script&lang=js"
export * from "./CardInvoices.vue?vue&type=script&lang=js"

import "./CardInvoices.vue?vue&type=style&index=0&id=78795394&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78795394"]])

export default __exports__